import { lazy } from "react";
import { Route } from "react-router-dom";

import MFAPositiveDataRoutes from "@shared/routes/MFAPositiveDataRoutes";

const CpfLookout = lazy(() => import("../pages/CpfLookout"));
const CpfAlert = lazy(() => import("../pages/CpfAlert"));
const ActivityHistory = lazy(() => import("../pages/CpfAlert/ActivityHistory"));
const BillsAndPayments = lazy(() => import("../pages/BillsAndPayments"));
const ProductList = lazy(() => import("../pages/ProductList"));
const ProductDetail = lazy(() => import("../pages/ProductDetail"));
const InstallmentDetail = lazy(() => import("../pages/InstallmentDetail"));

export function BureauPrivateRouter() {
	return (
		<>
			<Route element={<MFAPositiveDataRoutes />}>
				<Route path="/consultas-cpf" element={<CpfLookout />} />
				<Route path="/alerta-cpf" element={<CpfAlert />} />
				<Route path="/contas-pagamentos" element={<BillsAndPayments />} />
				<Route
					path="/contas-pagamentos/:categorySlug"
					element={<ProductList />}
				/>
				<Route
					path="/contas-pagamentos/:categorySlug/:productId"
					element={<ProductDetail />}
				/>
				<Route
					path="/contas-pagamentos/:categorySlug/:productId/:installmentId"
					element={<InstallmentDetail />}
				/>
			</Route>
			<Route path="/alerta-cpf/historico" element={<ActivityHistory />} />
		</>
	);
}
